module.exports = __webpack_public_path__ + "media/1alB-k-kua.44e18225.mp3";